import { render } from "./AddFactureS.vue?vue&type=template&id=15ddb9ba&ts=true"
import script from "./AddFactureS.vue?vue&type=script&lang=ts"
export * from "./AddFactureS.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__